import { createSlice } from '@reduxjs/toolkit';
import { planPaymentMode, coverageTypes, coverageTypeEnum } from 'common/utils/enums';

const initialState = {
  plansValues: {},
  plansStep: 0,
  isSubmitted: false,
  coverageSelection: {
    [coverageTypes.LEAVE_ANYTIME]: null,
    [coverageTypes.CANCEL_ANYTIME]: null,
  },
  coverageType: coverageTypeEnum.FULL, // Default to full coverage
  planPaymentMode: planPaymentMode.ONE_TIME,
  upfrontSplitAmount: null,
};

export const plansSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {
    saveDraftPlans: (state, { payload }) => ({
      ...state,
      plansStep: payload.plansStep,
      plansValues: payload.plansValues,
      isSubmitted: payload.isSubmitted,
    }),
    savePlansValues: (state, { payload }) => ({
      ...state,
      plansValues: payload,
    }),
    setIsSubmitted: (state, { payload }) => ({
      ...state,
      isSubmitted: payload,
    }),
    setPlanStep: (state, { payload: planStepPayload }) => ({
      ...state,
      plansStep: planStepPayload,
    }),
    savePlanPaymentMode: (state, { payload: paymentMode }) => ({
      ...state,
      planPaymentMode: paymentMode,
    }),
    saveCoverageSelection: (state, { payload: coverageSelection }) => ({
      ...state,
      coverageSelection,
    }),
    saveCoverageType: (state, { payload: coverageType }) => ({
      ...state,
      coverageType,
    }),
    saveUpfrontSplitAmount: (state, { payload: upfrontSplitAmount }) => ({
      ...state,
      upfrontSplitAmount,
    }),
    clearPlansDraft: () => initialState,
  },
});

// ACTIONS
export const {
  saveDraftPlans,
  savePlansValues,
  clearPlansDraft,
  setPlanStep,
  setIsSubmitted,
  savePlanPaymentMode,
  saveCoverageSelection,
  saveCoverageType,
  saveUpfrontSplitAmount,
} = plansSlice.actions;

// SELECTORS
export const selectPlansValues = (state) => state.plans.plansValues;
export const selectPlansStep = (state) => state.plans.plansStep;
export const selectIsSubmitted = (state) => state.plans.isSubmitted;
export const selectPlanID = (state) => state.plans.plansValues?.id || '';
export const selectPaymentMode = (state) => state.plans.planPaymentMode;
export const selectCoverageSelection = (state) => state.plans.coverageSelection;
export const selectCoverageType = (state) => state.plans.coverageType;
export const selectUpfrontSplitAmount = (state) => state.plans.upfrontSplitAmount;

// REDUCERS
export default plansSlice.reducer;
